import React from "react";
import SpecialtyConsole from "./SpecialtyConsole";

const CALCULATORS = [
  {
    name: "DAS28-CRP (Rheumatoid Arthritis)",
    endpoint: "das28-crp",
    fields: [
      { name: "tender_joints",     label: "Tender joints (0-28)" },
      { name: "swollen_joints",    label: "Swollen joints (0-28)" },
      { name: "crp_mg_l",          label: "CRP (mg/L)" },
      { name: "patient_global_vas", label: "Patient global VAS (0-100 mm)" },
    ],
    defaults: { tender_joints: 4, swollen_joints: 3, crp_mg_l: 8, patient_global_vas: 40 },
  },
  {
    name: "CDAI (labs-free RA activity)",
    endpoint: "cdai",
    fields: [
      { name: "tender_joints",     label: "Tender joints (0-28)" },
      { name: "swollen_joints",    label: "Swollen joints (0-28)" },
      { name: "patient_global_vas", label: "Patient global VAS (0-10 cm)" },
      { name: "physician_global_vas", label: "Physician global VAS (0-10 cm)" },
    ],
    defaults: { tender_joints: 4, swollen_joints: 3, patient_global_vas: 4, physician_global_vas: 3 },
  },
  {
    name: "SLEDAI-2K",
    endpoint: "sledai",
    fields: [
      { name: "present", label: "Items present (comma sep keys)",
        type: "text",
        parse: "string_list",
        placeholder: "e.g. rash,alopecia,arthritis,low_complement" },
    ],
    defaults: { present: "" },
  },
  {
    name: "Gout flare classifier (ACR 2020)",
    endpoint: "gout-flare",
    fields: [
      { name: "joints_involved",  label: "Joints involved" },
      { name: "monoarticular",    label: "Monoarticular?", type: "select",
        options: [{value: true, label: "Yes"}, {value: false, label: "No"}] },
      { name: "tophi_present",    label: "Tophi present?", type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "urate_mg_dl",      label: "Serum urate (mg/dL)" },
      { name: "prior_flares_year", label: "Flares in past year" },
    ],
    defaults: { joints_involved: 1, monoarticular: true, tophi_present: false,
                urate_mg_dl: 8.2, prior_flares_year: 1 },
  },
];

export default function Rheumatology() {
  return <SpecialtyConsole
    specialtyId="rheumatology"
    title="Rheumatology"
    tagline="RA, SLE, and autoimmune care"
    accent="#EC4899"
    calculators={CALCULATORS}
  />;
}
